import { ApolloCache } from 'apollo-cache';
import * as uuid from 'uuid';
import { GetAlertsQuery } from './queries';
import { AlertColor, AlertMessage, AlertsPayload } from './types';

/** Shows an alert message at the top of the screen */
export const addAlert = (
    { message, color }: { message: string; color?: AlertColor },
    cache: ApolloCache<any>
) => {
    const previous: AlertsPayload | null = cache.readQuery({
        query: GetAlertsQuery
    }) || { alerts: [] };

    const alerts = [...previous.alerts];
    const existing = alerts.find(a => a.message === message);

    const newAlert: AlertMessage = {
        __typename: 'AlertMessage',
        color: color || AlertColor.danger,
        count: existing && existing.count ? existing.count + 1 : 1,
        id: uuid.v4(),
        message
    };

    // Remove any alerts with the same message
    if (existing) {
        alerts.splice(alerts.indexOf(existing), 1);
    }

    // Insert the new item at the beginning of the list
    alerts.splice(0, 0, newAlert);

    const data = {
        __typename: 'AlertsPayload',
        alerts
    };

    cache.writeData({ data });
    return data;
};

export const removeAlert = (
    { message }: { message: string },
    cache: ApolloCache<any>
) => {
    const previous: AlertsPayload | null = cache.readQuery({
        query: GetAlertsQuery
    }) || { alerts: [] };

    const alerts = [...previous.alerts];

    const existing = alerts.find(a => a.message === message);

    // Remove any alerts with the same message
    if (existing) {
        alerts.splice(alerts.indexOf(existing), 1);
    }

    const data = {
        __typename: 'AlertsPayload',
        alerts
    };

    cache.writeData({ data });
    return data;
};

/** Shows an alert message at the top of the screen to inform the user that something is wrong */
export const postErrorAlert = (message: string, cache: ApolloCache<any>) =>
    addAlert({ message, color: AlertColor.danger }, cache);



// WEBPACK FOOTER //
// ./src/client/clientState/alerts/services.ts